import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React from "react";
import { Formik, Form } from "formik"; // import PropTypes from "prop-types";

import * as Yup from "yup";
import { Grid, Dialog } from "../../../../";
import { Debug } from "../../../../Molecules/Forms/Debug";
import { makeStyles } from "@material-ui/core/styles";
import { StepperHorizontal } from "../../../../Molecules/Stepper/Horizontal";
var taskSchema = Yup.object().shape({
  name: Yup.string().min(2, "Too Short!").required("Campo obligatorio") // deadline: Yup.date().default(() => new Date()),
  // details: Yup.string().min(2, 'Too Short!').required('Campo obligatorio')

});
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      "flex-wrap": "wrap"
    },
    mr30: {
      "margin-right": "30px"
    },
    flex: {
      display: "flex",
      "justify-content": "space-between"
    },
    w50: {
      width: "50%"
    },
    actions: {
      display: "flex",
      padding: "30px",
      "justify-content": "flex-end"
    }
  };
});

var DialogFranchiseAddInsideTask = function DialogFranchiseAddInsideTask(props) {
  var translation = props.translation;
  var classes = useStyles();
  var initialValues = {
    nameParent: "",
    name: "",
    start: null,
    end: null,
    type: "",
    frequency: "",
    repeat: false,
    status: "pending",
    weekdays: [],
    extraFields: [{
      "options": [{
        "name": ""
      }],
      "name": "t",
      "type": "textarea",
      "isMandatory": false
    }]
  };
  var title = "Añadir nueva tarea";
  return [/*#__PURE__*/React.createElement(Dialog, {
    fullWidth: true,
    maxWidth: "md",
    title: title,
    open: props.open,
    onClose: props.onClose,
    key: 0
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: props.data || initialValues,
    validationSchema: taskSchema,
    onSubmit: function onSubmit(values) {
      props.addInsideTask(_objectSpread(_objectSpread({}, values), {}, {
        repeat: values.type === "recurring"
      }));
      props.onClose();
    },
    render: function render(_ref) {
      var values = _ref.values,
          setFieldValue = _ref.setFieldValue,
          isValid = _ref.isValid,
          isSubmitting = _ref.isSubmitting,
          errors = _ref.errors,
          touched = _ref.touched;
      return /*#__PURE__*/React.createElement(Form, {
        className: classes.form
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.root
      }, /*#__PURE__*/React.createElement(StepperHorizontal, {
        variant: "projectAddInsideTask",
        values: values,
        setFieldValue: setFieldValue,
        errors: errors,
        touched: touched,
        translation: translation ? translation : null,
        isValid: isValid,
        isSubmitting: isSubmitting
      })));
    }
  })))];
};

export { DialogFranchiseAddInsideTask };